import { render, staticRenderFns } from "./policyAndLaw.vue?vue&type=template&id=139f467f&scoped=true"
import script from "./policyAndLaw.vue?vue&type=script&lang=js"
export * from "./policyAndLaw.vue?vue&type=script&lang=js"
import style0 from "./policyAndLaw.vue?vue&type=style&index=0&id=139f467f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139f467f",
  null
  
)

export default component.exports